import React, { useState } from 'react';
//import styled from 'styled-components';
import { Paragraph, Tab, Tabs, Grid, Box, Text, TextInput} from 'grommet';
import { PageHeader, Page, PageContent, Heading } from 'grommet';
//import { Hpe as HpeIcon, Search as SearchIcon } from 'grommet-icons';
//import { Search as SearchIcon,  Send as SendIcon } from 'grommet-icons';
import { PageFooter } from '../../components';
import { TabContent } from './TabContent';
import './page.css';  

const searchSuggestions = [
  'Sales & Marketing',
  'Source, Make & Deliver',
  'Billing & Accounting',
  'Support & Retention',
  'CPQ',
  'Integration Fabric',
  'Data Platform',
  'SAP',
  'Salesforce',
  'Testing Automation',
  'Hybrid Cloud',
  'Infrastructure',
  'Data & AI',
  'Supply Chain',
];


const HomePage = () => {
  const [index, setIndex] = useState();
  const onActive = nextIndex => setIndex(nextIndex);

  const [value, setValue] = React.useState();
  const [suggestions, setSuggestions] = React.useState(
    searchSuggestions.slice(0, 5),
  );

  const filterResults = query => {
    let resultSet;

    if (query) {
      const regexp = new RegExp(query, 'i');
      resultSet = searchSuggestions.filter(option => regexp.test(option));
    } else {
      resultSet = searchSuggestions;
    }
    return resultSet.slice(0, 5);
  };

  const onChange = event => {
    const {
      target: { value: nextValue },
    } = event;
    const nextSuggestions = filterResults(nextValue);

    setValue(nextValue);
    setSuggestions(nextSuggestions);
  };

  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);  // When focused, set the state to true
  };

  const handleBlur = () => {
    setIsFocused(false); // When blurred, set the state to false
  };

  //const [value, setValue] = React.useState('');
  //const size = useContext(ResponsiveContext);
  //const [focused] = useState(false);
  //const [focused, setFocused] = useState(false);

  return (

    <Page background="background-back">

      <PageContent flex="grow">

          <Box background="url('images/space-background.png')" height="170px"  margin={{ top: 'none' }}>
            <Box margin={{ top: 'none', left: 'medium' }}>
              <PageHeader pad={{ top: '15px', bottom: '15px' }} 
                          title={<Text color="white" size="xxlarge" weight="bolder" style={{fontWeight: 'bold'}}>Welcome to HPE IT's Road Map Explorer</Text>} 
                          subtitle={'Innovation and transformation journey insights.'}
                          style={{ color: 'white' }}
                          size='medium'/>

              <TextInput
                className="custom-placeholder"
                aria-label="search"
                placeholder={<Text color="white">Search by keyword, value chain or platform</Text>}
                onFocus={handleFocus}
                onBlur={handleBlur}
                style={{ borderColor: isFocused ? 'black' : 'white',  // Black when focused, white when not
                         color: 'white',
                }}
                reverse
                suggestions={suggestions}
                value={value}
                onChange={onChange}
                type="search"
                width="medium"
                margin={{ bottom: '15px' }} />

            </Box>
          </Box>

          <Heading size="medium" margin={{ top: 'large' }}>Explore HPE IT's direction and overall <b>North Star</b> </Heading>

          <Heading size="medium" margin={{ top: 'large' }}>Explore Road Map Priorities by <b>Value Chain</b> </Heading>

          <Grid
            rows={['xxsmall', 'xsmall']} // Define rows
            columns={['flex', 'flex', 'flex', 'flex', 'flex']} // Five columns for the header
            gap="xxsmall"
          >

            {/* Header row */}
            <Box gridArea="0/0/1/1" align="center" justify="center" background="brand">
              <Text weight="bold">01. Innovation & Forecasting</Text>
            </Box>
            <Box gridArea="0/1/1/2" align="center" justify="center" background="brand">
              <Text weight="bold">02. Sales & Marketing</Text>
            </Box>
            <Box gridArea="0/2/1/3" align="center" justify="center" background="brand">
              <Text weight="bold">03. Source, Make & Deliver</Text>
            </Box>
            <Box gridArea="0/3/1/4" align="center" justify="center" background="brand">
              <Text weight="bold">04. Billing & Accounting</Text>
            </Box>
            <Box gridArea="0/4/1/5" align="center" justify="center" background="brand">
              <Text weight="bold">05. Support & Retention</Text>
            </Box>

            <Box gridArea="1/0/2/1" align="center" justify="center" background="light-5">
              <Text>Upcoming...</Text>
            </Box>

          </Grid>



          <Heading size="medium" margin={{ top: 'large' }}>Explore Road Map Priorities by <b>Platform</b> </Heading>

            <Tabs activeIndex={index} onActive={onActive} justify="start">
              <Tab title="IT Hybrid Cloud">
                <TabContent>
                  <Paragraph margin="none">IT's hybrid cloud road map priorities coming soon!</Paragraph>
                </TabContent>
              </Tab>     
              <Tab title="Data & AI">
                <TabContent>
                  <Paragraph margin="none">Data & AI road map priorities coming soon!</Paragraph>
                </TabContent>
              </Tab>        
              <Tab title="Salesforce">
                <TabContent>
                  <Paragraph margin="none">
                    Salesforce roadmap priorities coming soon!
                  </Paragraph>
                </TabContent>
              </Tab>
              <Tab title="SAP">
                <TabContent>
                  <Paragraph margin="none">SAP roadmap priorities coming soon!</Paragraph>
                </TabContent>
              </Tab>
              <Tab title="Integration Fabric">
                <TabContent>
                  <Paragraph margin="none">Integration Fabric road map priorities coming soon!</Paragraph>
                </TabContent>
              </Tab>   
              <Tab title="Testing Automation">
                <TabContent>
                  <Paragraph margin="none">Testing Automation road map priorities coming soon!</Paragraph>
                </TabContent>
              </Tab>  
              <Tab title="Dev Tooling">
                <TabContent>
                  <Paragraph margin="none">Dev tooling road map priorities coming soon!</Paragraph>
                </TabContent>
              </Tab>                                             
            </Tabs>



      </PageContent>  

      <PageFooter/>

    </Page>

  );
};

export { HomePage as RoadmapsHome };